"use client";

import { c as _c } from "react/compiler-runtime";
import { getIconFromSlug, metadata } from "@app/_metadata";
import { RoboLion } from "@chat-ai/_components/robo-lion";
import { TopBar } from "@shared-components/global/top-bar";
import { api } from "@shared-server/api";
import { BETA_FLAG } from "@shared-utils/constants";
import { cn } from "@shared-utils/ui";
import { ListItem } from "@shared-components/list-item";
import { TutorialVideo } from "@shared-components/tutorial-video";
import Link from "next/link";
export default function DashboardPage() {
  const $ = _c(40);
  const activeFeatureFlags = api.feature.allEnabledForMe.useQuery();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== activeFeatureFlags.data) {
    const hasBetaFlag = activeFeatureFlags.data?.includes(BETA_FLAG);
    const allToolApps = metadata.aiTools.filter(_temp);
    const visibleToolApps = allToolApps.filter(appConfig_0 => !appConfig_0.requiredFeatureFlags || hasBetaFlag || appConfig_0.requiredFeatureFlags.every(flag => activeFeatureFlags.data?.includes(flag)));
    const heroTools = visibleToolApps;
    const heroToolCount = Math.max(heroTools.length, 1);
    const contentContainerClass = cn("lg:max-w-[1100px] lg:mx-auto");
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TopBar aiTools={[]} hideBottomBorder={true} />;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="absolute left-[80%] top-0 h-[556px] w-[100px] z-50 pointer-events-none hidden md:block" style={{
        backgroundImage: "url(\"/leo-outline-2.png\")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat"
      }} />;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t7;
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <h1 className="text-4xl font-medium">{"LEO AI"}</h1>;
      t8 = <RoboLion className="absolute bottom-0 left-5 top-[420px] z-10 fill-foreground w-9 h-9" />;
      $[10] = t7;
      $[11] = t8;
    } else {
      t7 = $[10];
      t8 = $[11];
    }
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="bg-sec-light-green dark:bg-sec-light-green/60 absolute left-[10%] md:left-[45%] top-32 bottom-24 w-[15%] md:w-[4%]" />;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    const t10 = `repeat(${heroToolCount}, minmax(0, 1fr))`;
    let t11;
    if ($[13] !== t10) {
      t11 = {
        gridTemplateRows: t10
      };
      $[13] = t10;
      $[14] = t11;
    } else {
      t11 = $[14];
    }
    const t12 = heroTools.map(_temp2);
    let t13;
    if ($[15] !== t11 || $[16] !== t12) {
      t13 = <div className="absolute left-[30%] md:left-[50%] top-32 bottom-24 z-10 px-4"><div className="grid h-full grid-cols-1 gap-2" style={t11}>{t12}</div></div>;
      $[15] = t11;
      $[16] = t12;
      $[17] = t13;
    } else {
      t13 = $[17];
    }
    let t14;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div style={{
        backgroundImage: "url(\"/skin.jpg\")",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }} className="absolute left-0 top-32 bottom-0 w-[20%] md:w-[45%] pl-24 z-5 dark:opacity-60" />;
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    t4 = <div className="w-full relative h-[500px]"><div className={cn(contentContainerClass, "p-4 pt-14 relative")}>{t7}{t8}</div>{t9}{t13}{t14}<div><div className={cn(contentContainerClass, "p-4 pt-16")} /></div></div>;
    let t15;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <h2 className="mb-2 text-xl font-heading font-medium">{"Tutorial Videos"}</h2>;
      $[19] = t15;
    } else {
      t15 = $[19];
    }
    let t16;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <a className="font-bold" href="https://leopharma.sharepoint.com/teams/LEO-PHARMA-ACADEMY/SitePages/LEO-OpenAI.aspx">{"LEO Academy"}</a>;
      $[20] = t16;
    } else {
      t16 = $[20];
    }
    let t17;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <p className="mb-8 mt-2 font-normal">{"Learn how to get the most out of LEO AI with quick, practical tutorials from the "}{t16}{"."}<br />{"Explore short videos (below) and level up your AI skills."}</p>;
      $[21] = t17;
    } else {
      t17 = $[21];
    }
    let t18;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <div className="mb-3 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">{metadata.tutorialVideos.map(_temp3)}</div>;
      $[22] = t18;
    } else {
      t18 = $[22];
    }
    t5 = <div className=" w-full relative bg-pri-light-blue dark:bg-pri-light-blue/10"><div className={cn(contentContainerClass, "p-4 py-8")}>{t15}{t17}{t18}</div></div>;
    let t19;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <div className="md:w-[35%] lg:w-[30%]"><h2 className="mb-2 text-xl font-medium font-heading mt-4">{"What's New"}</h2><p className="mb-4 whitespace-nowrap text-lg">{"See the latest updates, new tools, and improvements-freshly added to LEO AI."}</p>{metadata.updates.slice(0, 5).map(_temp4)}</div>;
      $[23] = t19;
    } else {
      t19 = $[23];
    }
    t6 = <div className=" w-full relative"><div className={cn(contentContainerClass, "p-4 py-8")}>{t19}</div></div>;
    t1 = "w-full bg-panel-50";
    t0 = cn(contentContainerClass, "grid gap-8 p-4 py-12 md:grid-cols-[1.2fr_1fr_1fr]");
    $[0] = activeFeatureFlags.data;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  let t8;
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><div className="flex items-center gap-2"><p className="text-sm font-heading font-medium">{"LEO AI"}</p><RoboLion className="h-4 w-4 fill-foreground" /></div><p className="mt-2 max-w-md text-sm">{"AI & Cloud Data Services"}</p></div>;
    t8 = <div><p className="text-xs font-medium font-heading text-foreground">{"Contact"}</p><p className="mt-2 text-sm mb-0">{"Alex Schuleit"}</p><a className="mt-1 inline-block text-sm font-medium underline underline-offset-4" href="mailto:alscu@leo-pharma.com?subject=LEO%20AI">{"alscu@leo-pharma.com"}</a></div>;
    t9 = <p className="text-xs font-medium font-heading text-foreground">{"Learn"}</p>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t10;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div>{t9}<div className="mt-2 flex flex-col gap-1 text-sm"><a className="w-fit font-medium underline underline-offset-4" href="https://leopharma.sharepoint.com/teams/LEO-PHARMA-ACADEMY/SitePages/LEO-OpenAI.aspx" target="_blank" rel="noreferrer">{"LEO Academy"}</a><a className="w-fit font-medium underline underline-offset-4" href="https://leopharma.sharepoint.com/teams/LEO-PHARMA-ACADEMY/Shared%20Documents/Digital%20Skills/LEO%20AI%20FAQ%2018Apr24.pdf" target="_blank" rel="noreferrer">{"FAQ"}</a></div></div>;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t0) {
    t11 = <div className={t0}>{t7}{t8}{t10}</div>;
    $[28] = t0;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t1 || $[31] !== t11) {
    t12 = <div className={t1}>{t11}</div>;
    $[30] = t1;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t2 || $[35] !== t3 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6) {
    t13 = <>{t2}{t3}{t4}{t5}{t6}{t12}</>;
    $[33] = t12;
    $[34] = t2;
    $[35] = t3;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  return t13;
}
function _temp4(update) {
  return <a href={update.url + "#" + update.key} key={update.url + "#" + update.key} className="group mb-4 block"><small className="text-xs text-ter-green-500 dark:text-[hsl(162_53%_45%)]">{update.date}</small><h3 className="text-sm font-medium group-hover:underline">{update.title}</h3></a>;
}
function _temp3(video, index_0) {
  return <TutorialVideo key={index_0} video={video} />;
}
function _temp2(appConfig_1, index) {
  return <ListItem asChild={true} variant="light" key={`${appConfig_1.slug}-${index}`} className={cn("text-xl")}><Link href={appConfig_1.slug} className={cn("flex h-full items-center gap-3 px-4 py-4 font-heading font-normal")}>{getIconFromSlug(appConfig_1.slug, {
        size: 28,
        strokeWidth: 1.5,
        className: cn(appConfig_1.meta.strokeColor, appConfig_1.meta.name === "LEO GPT" && "shrink-0")
      })}{appConfig_1.meta.name}</Link></ListItem>;
}
function _temp(appConfig) {
  return appConfig.tool;
}